import {
  MessageResponseDto,
  GetTransactionWaiverDto,
  CreateTransactionWaiverBaseDto,
  EditTransactionWaiverBaseDto,
  TransactionWaiverControllerGet200Response,
  TransactionWaiverApiFp,
  DeleteTransactionWaiverDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTransactionWaiverModel =
  TransactionWaiverControllerGet200Response;
export type GetTransactionWaiverModel = GetTransactionWaiverDto;
export type MutateResponseTransactionWaiverModel = MessageResponseDto;
export type CreateTransactionWaiverModel = CreateTransactionWaiverBaseDto;
export type UpdateTransactionWaiverModel = EditTransactionWaiverBaseDto;
export type DeleteTransactionWaiverModel = DeleteTransactionWaiverDto;


export interface CreateTransactionWaiverModelExtension {
  waiver: CreateTransactionWaiverModel;
  file: File;
}
export interface UpdateTransactionWaiverModelExtension {
  waiver: UpdateTransactionWaiverModel;
  file: File;
}

export const apiTransactionWaiverFp = TransactionWaiverApiFp(apiConfig);
export const getTransactionWaiverController =
  apiTransactionWaiverFp.transactionWaiverControllerGet;
export const createTransactionWaiverController =
  apiTransactionWaiverFp.transactionWaiverControllerCreate;
export const updateTransactionWaiverController =
  apiTransactionWaiverFp.transactionWaiverControllerEdit;
export const deleteTransactionWaiverController =
  apiTransactionWaiverFp.transactionWaiverControllerDelete;

export const QueryKeyTransactionWaiver = QueryKey.TransactionWaiver;
